import { createRouter, createWebHistory } from 'vue-router';
import { getCurrentStore, } from "@u/helpers/utils"

const m = import.meta.glob('../views/**/*.vue');
const load = (path) => m[`../views/${path}.vue`];

/**
 * constantRoutes
 * 不需要身份认证 所有情况都可以访问的页面
 */
export const constantRoutes = [
  {
    path: '/404', name: 'error404', component: load('404'),
    meta: { requireAuth: false, title: 'router.404', description: 'description.404' }
  },
  {
    path: '/500', name: '500', component: load('500'),
    meta: { requireAuth: false, title: 'router.500', description: 'description.500' }
  },
  {
    path: '/login', name: 'login', component: load('login'),
    meta: { requireAuth: false, title: 'router.login', description: 'description.login' }
  },
  {
    path: '/register', name: 'register', component: load('register'),
    meta: { requireAuth: false, title: 'router.register', description: 'description.register' }
  },
  {
    path: '/reset', name: 'reset', component: load('reset'),
    meta: { requireAuth: false, title: 'router.reset', description: 'description.reset' }
  },
  {
    path: '/activate', name: 'activate', component: load('activate'),
    meta: { requireAuth: false, title: 'router.activate', description: 'description.activate' }
  },
  {
    path: '/identification', name: 'identification', component: load('identification'),
    meta: { requireAuth: false, title: 'router.activate', description: 'description.activate' }
  },
  {
    path: '/policies', name: 'policies', component: load('policies/layout'),
    meta: { requireAuth: false, },
    children: [
      {
        path: 'terms-of-service', name: 'terms-of-service', component: load('policies/terms-of-service'),
        meta: { requireAuth: false, title: 'router.termsOfService', description: 'description.termsOfService' },
      },
      {
        path: 'privacy-policy', name: 'privacy-policy', component: load('policies/privacy-policy'),
        meta: { requireAuth: false, title: 'router.privacyPolicy', description: 'description.privacyPolicy' },
      }
    ]
  },
  {
    path: '/index', name: 'layout', component: load('index/layout'),
    meta: { requireAuth: false, },
    children: [
      {
        path: '', name: 'index', component: load('index/index'),
        meta: { requireAuth: false, title: 'router.memberIndex', description: 'description.memberIndex' },
      },
      {
        path: 'guide', name: 'guide', component: load('index/guide'),
        meta: { requireAuth: false, title: 'router.memberGuide', description: 'description.memberGuide' },
      }
    ]
  },
  {
    path: '/id',
    name: 'id',
    redirect: '/account',
    meta: {
      permissions: ['US', 'CA', 'GB', 'DE', 'FR', 'IT', 'ES', 'JP', 'AU', 'EU']
    }
  },
  {
    path: '/', name: 'home',
    redirect: '/account',
    meta: { requireAuth: true, title: 'router.home', description: 'description.home' },
    children: []
  },
  // { path: '/:catchAll(.*)', redirect: '/404', hidden: true }
]

/** 权限路由 */
export const dynamicRoutes = [
  {
    path: '/account',
    name: 'account',
    component: () => import('@/views/home.vue'),
    redirect: '/account/overview',
    meta: { requireAuth: true, title: 'router.home', description: 'description.home' },
    children: [
      // 概览
      {
        path: 'overview',
        name: 'accountOverview',
        component: () => import('@/views/account/overview.vue'),
        meta: {
          requireAuth: true,
          title: 'router.overview',
          description: 'description.accountOverview',
          icon: 'icon-a-Overview',
          permissions: ['US', 'CA', 'GB', 'DE', 'FR', 'IT', 'ES', 'JP', 'AU', 'EU']
        }
      },

      // --- Accounts 分组 ---
      {
        path: 'profile',
        name: 'accountProfile',
        component: () => import('@/views/account/profile.vue'),
        meta: {
          requireAuth: true,
          title: 'router.accounts.profile',
          description: 'description.profile',
          icon: 'icon-a-MyProfile',
          group: 'router.accounts.groupName', // 用于菜单分组
          permissions: ['US', 'CA', 'GB', 'DE', 'FR', 'IT', 'ES', 'JP', 'AU', 'EU']
        }
      },
      {
        path: 'address',
        name: 'accountAddress',
        component: () => import('@/views/account/address/index.vue'),
        meta: {
          requireAuth: true,
          title: 'router.accounts.shippingAddress',
          description: 'description.addressBook',
          icon: 'icon-a-MyAddress',
          group: 'router.accounts.groupName',
          permissions: ['US', 'CA', 'GB', 'DE', 'FR', 'IT', 'ES', 'JP', 'AU', 'EU']
        }
      },
      {
        path: 'setting',
        name: 'accountSetting',
        component: () => import('@/views/account/setting.vue'),
        meta: {
          requireAuth: true,
          title: 'router.accounts.manageAccount',
          icon: 'icon-a-ManageAccount',
          group: 'router.accounts.groupName',
          permissions: ['US', 'CA', 'GB', 'DE', 'FR', 'IT', 'ES', 'JP', 'AU', 'EU']
        }
      },

      // --- Orders & Services 分组 ---
      {
        path: 'order',
        name: 'accountOrder',
        component: () => import('@/views/account/order/index.vue'),
        meta: {
          requireAuth: true,
          title: 'router.ordersAndService.orderStatus',
          description: 'description.orderStatus',
          icon: 'icon-a-MyOrders',
          group: 'router.ordersAndService.groupName',
          permissions: ['US', 'CA', 'GB', 'DE', 'FR', 'IT', 'ES', 'JP', 'AU', 'EU']
        }
      },
      {
        path: 'devices',
        name: 'accountDevices',
        component: () => import('@/views/account/devices.vue'),
        meta: {
          requireAuth: true,
          title: 'router.ordersAndService.warranty',
          description: 'description.warranty',
          icon: 'icon-a-MyDevice',
          group: 'router.ordersAndService.groupName',
          permissions: ['US', 'CA', 'GB', 'DE', 'FR', 'IT', 'ES', 'JP', 'AU', 'EU']
        }
      },
      {
        path: 'trade-in',
        name: 'accountTradeIn',
        component: () => import('@/views/account/trade-in.vue'),
        meta: {
          requireAuth: true,
          title: 'router.ordersAndService.tradeInProgram',
          description: 'description.tradeInProgram',
          icon: 'icon-a-MyTrade-In',
          group: 'router.ordersAndService.groupName',
          permissions: ['US', 'GB', 'DE']
        }
      },
      {
        path: 'my-extended-warranty',
        name: 'accountPEW',
        component: () => import('@/views/account/paidExtendedWarranty.vue'),
        meta: {
          requireAuth: true,
          title: 'router.ordersAndService.paidService',
          icon: 'icon-a-MyExtendedWarrany',
          group: 'router.ordersAndService.groupName',
          permissions: ['US']
        }
      },

      // --- Rewards & Benefits 分组 ---
      {
        path: 'wallet',
        name: 'accountWallet',
        component: () => import('@/views/account/wallet.vue'),
        meta: {
          requireAuth: true,
          title: 'router.rewardsAndActivities.walletAndRewards',
          description: 'description.walletAndRewards',
          icon: 'icon-a-MyWallet',
          group: 'router.rewardsAndActivities.groupName',
          permissions: ['US', 'CA', 'GB', 'DE', 'FR', 'IT', 'ES', 'JP', 'AU', 'EU']
        }
      },
      {
        path: 'referral',
        name: 'accountReferral',
        component: () => import('@/views/account/referral.vue'),
        meta: {
          requireAuth: true,
          title: 'router.rewardsAndActivities.referralProgram',
          description: 'description.referralProgram',
          icon: 'icon-a-MyReferral-new',
          group: 'router.rewardsAndActivities.groupName',
          permissions: ['US', 'CA', 'GB', 'DE', 'AU', 'EU', 'FR', 'JP']
        }
      },
      {
        path: 'jackeryStories',
        name: 'accountJackeryLife',
        component: () => import('@/views/account/jackeryStories.vue'),
        meta: {
          requireAuth: true,
          title: 'router.rewardsAndActivities.jackeryStories',
          description: 'description.jackeryStories',
          icon: 'icon-a-JackeryStories',
          group: 'router.rewardsAndActivities.groupName',
          permissions: ['US', 'CA', 'DE', 'GB']
        }
      }
    ]
  }
];


function filterRoutes(CR) {
  const cr = CR || getCurrentStore()?.cr || 'US';
  return dynamicRoutes.map(route => ({
    ...route,
    children: route.children.filter(childRoute => {
      // 只保留有权限的叶子路由
      return childRoute.meta.permissions?.includes(cr);
    })
  }));
}


const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from) {
    return { x: 0, y: 0 }
  },
  routes: constantRoutes
});


// 生成菜单
export function generateMenu() {
  const cr = getCurrentStore()?.cr || 'US';
  const accountRoute = dynamicRoutes.find(r => r.path === '/account');
  if (!accountRoute) return {};

  const filteredChildren = accountRoute.children.filter(child => {
    return child.meta.requireAuth !== false &&
      Array.isArray(child.meta.permissions) &&
      child.meta.permissions.includes(cr);
  });

  return filteredChildren.reduce((acc, route) => {
    const group = route.meta.group || '';
    acc[group] = acc[group] || [];
    acc[group].push(route);
    return acc;
  }, {});
}

/** 初始路由 */
export default router;
